export default "__VITE_ASSET__DxMB$BuT__"